<template>
  <li class="nav-item dropdown dropdown-user">
    <a
      class="nav-link dropdown-toggle dropdown-user-link p-0"
      id="dropdown-user"
      href="#"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <div class="user-nav d-none d-sm-flex">
        <span class="user-name fw-bolder">{{ user.name }}</span>
      </div>
      <span class="avatar avatar-sm">
        <img class="round" :src="profile.photo" alt="avatar" height="40" width="40" />
        <span class="avatar-status-online"></span>
      </span>
    </a>
    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdown-user">
      <router-link to="/profile" class="dropdown-item">
        <img class="user-dropdown-icon" width="14" src="/app-assets/images/icons/home.svg" alt=""> Home
      </router-link>
      <router-link :to="{'name': 'contact.myProfile.show'}" class="dropdown-item">
        <img class="user-dropdown-icon" width="14" src="/app-assets/images/icons/user.svg" alt=""> My Profile
      </router-link>
      <a @click.prevent="logout" class="dropdown-item">
        <img class="user-dropdown-icon" width="14" src="/app-assets/images/icons/power.svg" alt=""> Logout
      </a>
    </div>
  </li>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'UserProfile',
  props: {
    user: {
      type: Object,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  setup() {
    const router = useRouter();

    const logout = () => {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("X-Public-Token");
      localStorage.removeItem("quickAddCache");
      router.push('/login');
    };

    return { logout };
  }
};
</script>

<style scoped>
.dropdown-user .nav-link { display: flex; align-items: center; gap: 8px; padding: 0 0 0 4px !important; }
.user-nav { flex-direction: column; }
.user-name { 
    margin-top: 7px;
    font-size: 1rem;
    color: #2d3748;
    white-space: nowrap;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.avatar.avatar-sm { position: relative; }
.avatar-status-online {
  width: 9px; height: 9px; background: #28c76f; border-radius: 50%;
  border: 2px solid #fff; position: absolute; bottom: 0; right: 0;
}
.user-dropdown-icon { margin-right: 10px; }
.avatar.avatar-sm img {
  width : 40px !important;
  height : 40px !important;
}
@media (max-width: 575.98px) {
  .dropdown-user .nav-link { padding: 0 !important; }
  .avatar.avatar-sm img { width: 32px !important; height: 32px !important; }
  .avatar-status-online { width: 8px; height: 8px; border-width: 1.5px; }
}
</style>
